import type { propsInterface as TTitlePropsInterface } from '~~/modules/design-system/components/t-title/index.vue'

const sectionTitle: TTitlePropsInterface = {
  tag: 'h2',
  size: '2xl',
  classes: 'mb-6',
  leading: 'tight',
}

export { sectionTitle }
